/**
 * Voice transcription client.
 *
 * POSTs a recorded audio blob to the assistant backend and returns the
 * transcribed text. The text is placed in the composer for the user to review;
 * it is NOT sent to the model here.
 */

import { getValidAccessTokenFromStorage } from "@weco/suite-client";

const TRANSCRIBE_ENDPOINT = "/api/assistant/voice/transcribe/";

function extFor(type: string): string {
  if (type.includes("mp4")) return "mp4";
  if (type.includes("ogg")) return "ogg";
  if (type.includes("mpeg")) return "mp3";
  if (type.includes("wav")) return "wav";
  return "webm";
}

export async function transcribeAudio(blob: Blob, language?: string): Promise<string> {
  const token = await getValidAccessTokenFromStorage();
  const form = new FormData();
  form.append("file", blob, `voice.${extFor(blob.type)}`);
  if (language) form.append("language", language);

  const resp = await fetch(TRANSCRIBE_ENDPOINT, {
    method: "POST",
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: form,
  });

  if (!resp.ok) {
    let msg = `Transcription failed (${resp.status})`;
    try {
      const body = await resp.json();
      if (body?.error) msg = typeof body.error === "string" ? body.error : msg;
    } catch {
      /* ignore */
    }
    throw new Error(msg);
  }

  const data = await resp.json();
  return String(data.text ?? "").trim();
}
